// FQ開発環境2nd@AWS
export const API_BASE_URI = "https://develop-2nd.sx-progress.work/api/v1";
